import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Переключатель темы. Одна кнопка вместо триады light/dark/system:
 * «как в системе» остаётся стартовым состоянием, но как отдельный
 * пункт меню не нужен — по клику пользователь всегда хочет другую тему,
 * а не диалог о том, чьё мнение о теме важнее.
 */
export const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { theme, toggle } = useTheme();
  const { t } = useLanguage();
  const toDark = theme === 'light';

  return (
    <button
      type="button"
      onClick={toggle}
      className={className ? `m3-icon-btn m3-theme-toggle ${className}` : 'm3-icon-btn m3-theme-toggle'}
      aria-label={toDark ? t.common.themeSwitchToDark : t.common.themeSwitchToLight}
      title={toDark ? t.common.themeDark : t.common.themeLight}
    >
      {/* Обе иконки в разметке всегда: переход между ними — поворот и
          масштаб, а не подмена узла, иначе анимировать нечего. */}
      <span className="m3-theme-toggle-stack" aria-hidden>
        <svg className="m3-theme-toggle-sun" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
        <svg className="m3-theme-toggle-moon" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.3 14.2A8.4 8.4 0 0 1 9.8 3.7a8.5 8.5 0 1 0 10.5 10.5z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};
